<script setup>
  /**
   * App.vue - Root component
   * OP-2026-0129: Frontend Admin SaaS
   */
  import { computed } from 'vue'
  import { useAuthStore } from './stores/auth'
  import LoadingSpinner from './components/common/LoadingSpinner.vue'

  const authStore = useAuthStore()

  const isLoading = computed(() => authStore.loading)
</script>

<template>
  <!-- Loading inicial -->
  <LoadingSpinner v-if="isLoading" fullscreen message="Carregando..." />

  <!-- Router view -->
  <router-view v-else />
</template>
